import * as React from 'react';

function SvgArrowEuro(props) {
  return (
    <svg
      width={41.016}
      height={284}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        stroke="#cfcfcf"
        strokeWidth={3}
        strokeLinecap="round"
        d="M5.095 141.5h11"
      />
      <path
        stroke="#cfcfcf"
        strokeWidth={5}
        d="M11.168 17.011l-1.073 249.997"
      />
      <path
        d="M10.229.5a1 1 0 011.732 0l9.093 15.75a1 1 0 01-.866 1.5H2.001a1 1 0 01-.866-1.5zM10.96 283.5a1 1 0 01-1.731 0L.135 267.75a1 1 0 01.866-1.5h18.187a1 1 0 01.866 1.5z"
        fill="#cfcfcf"
      />
      <g>
        <path
          d="M27.2557 140.358L26.8636 141.21H21.3068L21.6136 140.358H27.2557ZM26.5227 142.062L26.1307 142.915H21.3068L21.6136 142.062H26.5227ZM28.2614 138.057L27.8523 138.943C27.6705 138.778 27.4787 138.636 27.277 138.517C27.0753 138.398 26.8636 138.305 26.642 138.24C26.4205 138.175 26.1875 138.142 25.9432 138.142C25.4602 138.142 25.0256 138.276 24.6392 138.543C24.2528 138.81 23.9474 139.203 23.723 139.723C23.4986 140.243 23.3864 140.881 23.3864 141.636C23.3864 142.392 23.4986 143.03 23.723 143.55C23.9474 144.07 24.2528 144.463 24.6392 144.73C25.0256 144.997 25.4602 145.131 25.9432 145.131C26.1932 145.131 26.429 145.098 26.6506 145.033C26.875 144.967 27.0838 144.878 27.277 144.764C27.473 144.651 27.6534 144.523 27.8182 144.381L28.2443 145.267C27.946 145.548 27.5966 145.761 27.196 145.906C26.7955 146.048 26.3778 146.119 25.9432 146.119C25.2443 146.119 24.625 145.938 24.0852 145.574C23.5483 145.21 23.1264 144.693 22.8196 144.023C22.5156 143.352 22.3636 142.557 22.3636 141.636C22.3636 140.716 22.5156 139.92 22.8196 139.25C23.1264 138.58 23.5483 138.062 24.0852 137.699C24.625 137.335 25.2443 137.153 25.9432 137.153C26.3949 137.153 26.8168 137.232 27.2088 137.388C27.6037 137.544 27.9545 137.767 28.2614 138.057ZM32.9521 137.273V146H31.8952V138.381H31.8441L29.7134 139.795V138.722L31.8952 137.273H32.9521Z"
          fill="#818181"
        />
      </g>
    </svg>
  );
}

export default SvgArrowEuro;
